export const React_Google_API_Key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY; // CHANGE 06-August-24
